import styled from 'styled-components';

export const ChartDownloadButton = styled.button`
    position: absolute;
    right: 0;
    top: 0;
    height: 44px;
    padding: 10px;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    pointer-events: none;
    svg {
        path {
            stroke: black;
        }
    }
`;

export const ChartWrapper = styled.div`
    position: relative;

    max-width: 100%;
    width: 100%;

    &:hover > ${ChartDownloadButton} {
        opacity: 1;
        pointer-events: all;
    }
`;
